
import { serviceInstance, wcfInstance } from "../axiosinstance";
import { getSession } from '../getSession';
import { APPOINTMENT_TYPES } from '../config/constants';
import API_ENDPOINTS from '../config/apiEndpoints';

export const sendMassSequenceNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/AddMassSequence_New', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassSequenceNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}
export const getActivityMasters = async (payload) => {
    try {
        const response = await serviceInstance.post('AddOn/GetActivityMasters', payload);
        return response.data;
    } catch (error) {
        console.error('getActivityMasters error:', error);
        throw error;
    }
}
export const getActivityDetailById = async (payload) => {
    try {
        const response = await serviceInstance.post('AddOn/GetActivityDetailById', payload);
        return response.data;
    } catch (error) {
        console.error('getActivityDetailById error:', error);
        throw error;
    }
}
export const removeCustomEvent = async (payload) => {
    try {
        const response = await serviceInstance.post('AddOn/RemoveCustomEvent', payload);
        return response.data;
    } catch (error) {
        console.error('removeCustomEvent error:', error);
        throw error;
    }
}
export const saveActivityMaster = async (payload) => {
    try {
        const response = await serviceInstance.post('AddOn/SaveAcitivityMaster', payload);
        return response.data;
    } catch (error) {
        console.error('saveActivityMaster error:', error);
        throw error;
    }
}
export const updateActivityStatus = async (payload) => {
    try {
        const response = await serviceInstance.post('AddOn/UpdateActivityStatus', payload);
        return response.data;
    } catch (error) {
        console.error('updateActivityStatus error:', error);
        throw error;
    }
}
export const getEventDetailList = async (payload) => {
    try {
        const response = await serviceInstance.post('AddOn/GetEventDetailList', payload);
        return response.data;
    } catch (error) {
        console.error('getEventDetailList error:', error);
        throw error;
    }
}
export const getLeadList = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetLeadListNew', payload)
        return response.data
    }
    catch (error) {
        console.error('getLeadList error:', error);
        throw error;
    }
}

export const getLeadDetailList = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetLeadDetailListNew', payload)
        return response.data
    }
    catch (error) {
        console.error('getLeadDetailList error:', error);
        throw error;
    }
}

export const getLeadTemplateJson = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetLeadTemplateJson', payload)
        return response.data
    }
    catch (error) {
        console.error('getLeadTemplateJson error:', error);
        throw error;
    }
}

export const getPredefinedMappings = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetPredefinedMappings', payload)
        return response.data
    }
    catch (error) {
        console.error('getPredefinedMappings error:', error);
        throw error;
    }
}

export const getMappingFieldColumns = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetMappingFieldColumns', payload)
        return response.data
    }
    catch (error) {
        console.error('getMappingFieldColumns error:', error);
        throw error;
    }
}

export const addLeadImportSummary = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/AddLeadImportSummary_New', payload)
        return response.data
    }
    catch (error) {
        console.error('AddLeadImportSummary_New error:', error);
        throw error;
    }
}

export const getMappingByDropdownSelection = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetMappingByDropdownSelection', payload);
        return response.data;
    } catch (error) {
        console.error('getMappingByDropdownSelection error:', error);
        throw error;
    }
}

export const updateMassLeadEnquiryFromExcel = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/UpdateMassLeadEnquiryFromExcel_New', payload)
        return response.data
    }
    catch (error) {
        console.error('UpdateMassLeadEnquiryFromExcel_New error:', error);
        throw error;
    }
}

export const getLeadActivities = async (payload) => {
    try {
        // const response = await wcfInstance.post('UserCRMCampaign/Service/IMSService.asmx/GetLeadActivity', payload)
        const response = await serviceInstance.post('UserCRM/GetLeadActivity', payload)
        return response.data
    } catch (error) {
        console.error('getLeadActivities error:', error);
        throw error;
    }
}

export const getCallLogt = async (payload) => {
    try {
        // const response = await wcfInstance.post('UserCRMCampaign/Service/CRMService.asmx/getCallLog', {
        const response = await serviceInstance.post('UserCRM/GetCallLog', payload)
        return response.data
    } catch (error) {
        console.error('getCallLogt error:', error);
        throw error;
    }
}

export const getExportLeadDetails = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetExportLeadDetails', payload)
        return response.data
    } catch (error) {
        console.error('getExportLeadDetails error:', error);
        throw error;
    }
}

export const getPhysiscalAppointmentWidgetList = async (entityId, entityName) => {
    try {
        const response = await wcfInstance.post('UserCRMCampaign/Service/ToDoService.asmx/GetPhysicalAppointmentWidgetList', {
            EntityId: entityId,
            EntityName: entityName
        })

        // const response = await serviceInstance.post('UserCRMCampaign/Service/ToDoService.asmx/GetPhysicalAppointmentWidgetList', {
        //     EntityId: entityId,
        //     EntityName: entityName
        // })
        return response.data
    } catch (error) {
        console.error('getPhysiscalAppointmentWidgetList error:', error);
        throw error;
    }
}

export const getVirtulAPList = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetTaskHistoryListByUserId', payload);
        return response.data;
    } catch (error) {
        console.error('getVirtulAPList error:', error);
        throw error;
    }
}

export const getUpcomingMeetingDetails = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/BindUpcomingMeetingDetails', payload);
        return resp.data;
    } catch (err) {
        console.error('getUpcomingMeetingDetails error', err);
        throw err;
    }
}

export const getPastMeetingDetails = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/BindPastMeetingDetails', payload);
        return resp.data;
    } catch (err) {
        console.error('getPastMeetingDetails error', err);
        throw err;
    }
}

export const getParticipantsDetails = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetParticipantsDetails', payload);
        return resp.data;
    } catch (err) {
        console.error('getParticipantsDetails error', err);
        throw err;
    }
}

export const getTaskHistoryListByUserId_new = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetTaskHistoryListByUserId_new', payload);
        return response.data;
    } catch (error) {
        console.error('getTaskHistoryListByUserId_new error:', error);
        throw error;
    }
}

export const getWebformDetailsByLeadId = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetWebformDetailsByLeadId', payload);
        return response.data;
    } catch (error) {
        console.error('getWebformDetailsByLeadId error:', error);
        throw error;
    }
}

export const getPipelineHistoryByLeadID = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/PipelineHistoryByLeadID', payload);
        return response.data;
    } catch (error) {
        console.error('getPipelineHistoryByLeadID error:', error);
        throw error;
    }
}

export const getTawkToChatLogsByLeadId = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetTawkToChatLogsByLeadId', payload);
        return response.data;
    } catch (error) {
        console.error('getTawkToChatLogsByLeadId error:', error);
        throw error;
    }
}
export const getConvUserByLeadId = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/getConvUserID_new1', payload);
        return response.data;
    } catch (error) {
        console.error('getConvUserID_new1 error:', error);
        throw error;
    }
}

export const getConversationAsRequiredConvId = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetConversationAsRequiredConvId', payload);
        return response.data;
    } catch (error) {
        console.error('getConversationAsRequiredConvId error:', error);
        throw error;
    }
}

export const getFollowupsByLeadId = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetData', payload);
        return response.data;
    } catch (error) {
        console.error('getFollowupsByLeadId error:', error);
        throw error;
    }
}

export const getNotesByLeadId = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetNotes', payload);
        return response.data;
    } catch (error) {
        console.error('GetNotes error:', error);
        throw error;
    }
}

export const getDocumentsByLeadId = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetDocuments', payload);
        return response.data;
    } catch (error) {
        console.error('getDocumentsByLeadId error:', error);
        throw error;
    }
}

export const getNotifications = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/DisplayNotification', payload);
        return response.data;
    } catch (error) {
        console.error('getNotifications error:', error);
        throw error;
    }
}

export const updateDialerData = async (payload) => {
    try {
        const response = await serviceInstance.post('DialerSetting/UpdateDialerData', payload);
        return response.data;
    } catch (error) {
        console.error('updateDialerData error:', error);
        throw error;
    }
}

export const getScheduleCallAction = async (payload) => {
    try {
        const response = await serviceInstance.post('DialerSetting/GetScheduleCallAction', payload);
        return response.data;
    } catch (error) {
        console.error('getScheduleCallAction error:', error);
        throw error;
    }
}

export const getUserFromHashedList = async (payload) => {
    try {
        const response = await serviceInstance.post('Common/GetUserFromHashedList', payload);
        return response.data;
    } catch (error) {
        console.error('getUserFromHashedList error:', error);
        throw error;
    }
}

export const addNotes = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/AddNotes', payload);
        return response.data;
    } catch (error) {
        console.error('addNotes error:', error);
        throw error;
    }
}

export const deleteNotes = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/DeleteNotes', payload);
        return response.data;
    } catch (error) {
        console.error('deleteNotes error:', error);
        throw error;
    }
}

export const deleteDocument = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/DeleteDocument', payload);
        return response.data;
    } catch (error) {
        console.error('deleteDocument error:', error);
        throw error;
    }
}

export const getDIDNumbers = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetDIDNumbers', payload);
        return response.data;
    } catch (error) {
        console.error('getDIDNumbers error:', error);
        throw error;
    }
}

export const getVoiceDni = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/VoiceDni', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list
        }

        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getVoiceDni error', err?.message || err)
        return []
    }
}

export const getVoicePhonedetails = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/VoicePhonedetails', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list
        }

        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getVoicePhonedetails error', err?.message || err)
        return []
    }
}

export const bindUpdateFields = async ({ tableName = '', scheduledatetimeforlead = '', UserId = '' } = {}) => {
    try {
        const params = { tableName, scheduledatetimeforlead, UserId }
        const resp = await wcfInstance.post(`/UserCRMCampaign/Service/CRMService.asmx/BindUpdateField`, params)
        let list = resp?.data ?? resp

        // handle common WCF shapes: { d: "[...]" } or { d: [...] }
        if (list && typeof list === 'object' && list.d) list = list.d
        if (typeof list === 'string') {
            try { list = JSON.parse(list) } catch (e) { /* ignore parse error */ }
        }

        if (!Array.isArray(list)) return []
        return list.filter(v => v.FieldID !== 'StagesId').map(v => {
            let meta = null
            try { if (v.FieldDetail) meta = JSON.parse(v.FieldDetail)[0] } catch (e) { }
            return { key: String(v.FieldID), label: String(v.FieldName), tableName: v.TABLE_NAME, fieldType: v.FieldType, meta }
        })
    } catch (err) {
        console.warn('bindUpdateFields error', err)
        return []
    }
}

export const fetchCountries = async () => {

    try {
        const resp = await wcfInstance.post(`/UserCRMCampaign/Service/CRMService.asmx/BindCountry`, {})
        let list = resp?.data ?? resp

        // WCF wraps the array under { d: [...] }
        if (list && typeof list === 'object' && list.d) list = list.d
        if (typeof list === 'string') {
            try { list = JSON.parse(list) } catch (e) { /* ignore */ }
        }

        if (Array.isArray(list)) return list.map(c => ({ value: c.CountryID, label: c.CountryName }))
        return []
    } catch (e) {
        console.warn('fetchCountries error', e)
        return []
    }
}

export const fetchSourceValues = async ({ type = '', UserId = '' } = {}) => {
    try {
        const params = { type, UserId }
        const resp = await wcfInstance.post(`/UserCRMCampaign/Service/CRMService.asmx/BindSourceMediumCampaign`, params)
        let list = resp?.data ?? resp

        if (list && typeof list === 'object' && list.d) list = list.d
        if (typeof list === 'string') {
            try { list = JSON.parse(list) } catch (e) { /* ignore */ }
        }

        if (Array.isArray(list)) return list.map(s => ({ value: s.SrcmedCampID, label: s.SrcmedCampName }))
        return []
    } catch (e) {
        console.warn('fetchSourceValues error', e)
        return []
    }
}

export const getSequence = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetSequence', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list
        }

        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getSequence error', err?.message || err)
        return []
    }
}

export const getAppNames = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetAppNames', payload);
        return response.data;
    } catch (error) {
        console.error('getAppNames error:', error);
        throw error;
    }
}

export const getMeetingSettingList = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/GetMeetingSettingList', payload);
        return response.data;
    } catch (error) {
        console.error('getMeetingSettingList error:', error);
        throw error;
    }
}

export const sendVoiceEnquiryOrLead = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/SendVoiceEnquiryOrLead', payload);
        return response.data;
    } catch (error) {
        console.error('sendVoiceEnquiryOrLead error:', error);
        throw error;
    }
}
// Fetch appointment types from backend if available, otherwise return a sensible fallback
export const getAppointmentTypes = async (payload = {}) => {
    try {
        // try a common endpoint - backend may or may not expose this
        const response = await serviceInstance.post('UserCRM/GetTaskTypeByMode', payload);
        return response.data;
    } catch (error) {
        console.warn('getAppointmentTypes API not available, falling back to constants:', error?.message || error);
        // Normalize fallback into an array-like shape similar to other helpers
        const fallback = [
            { id: 'virtual', name: APPOINTMENT_TYPES.VIRTUAL || 'Virtual', value: 'virtual', text: APPOINTMENT_TYPES.VIRTUAL || 'Virtual' },
            { id: 'inperson', name: APPOINTMENT_TYPES.PHYSICAL || 'In Person', value: 'inperson', text: APPOINTMENT_TYPES.PHYSICAL || 'In Person' },
            { id: 'phone', name: 'Phone Call', value: 'phone', text: 'Phone Call' }
        ];
        return { Details: fallback };
    }
}

export const physicalAppointmentInsert = async (details) => {
    try {
        const { userId, TokenId } = getSession();
        const payload = {
            Token: TokenId,
            Message: '',
            LoggedUserId: userId,
            MAC_Address: '',
            IP_Address: '',
            Details: details,
            BroadcastName: ''
        };
        const resp = await serviceInstance.post('EmployeeTracker/PhysicalAppointmentInsert', payload);
        return resp?.data ?? resp;
    } catch (err) {
        console.error('physicalAppointmentInsert error:', err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}
export const getFromMailId = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetFromMailId', payload)
        // axios-style response: resp.data may contain { Details: [...] }
        const body = resp?.data ?? resp
        // prefer Details container when present
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Accounts ?? list.Details ?? list
        }

        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getFromMailId error', err?.message || err)
        return []
    }
}
export const getMailTemplate = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetMailTemplate', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Templates ?? list
        }


        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getMailTemplate error', err?.message || err)
        return []
    }
}
export const getTemplateContentById = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetMailTemplateSubject', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('getTemplateContentById error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error', Details: '' }
    }
}
export const sendMassMailNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SendMassMail_New', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassMailNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}
export const sendEmail = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SendEmail', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendEmail error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}
export const replaceJsonStr = async ({ jsonStr, entity, entityId }) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/IMSService.asmx/ReplacedJsonStr', {
            jsonStr,
            entity,
            entityId
        });
        const body = resp?.data ?? resp;
        const replaced = body?.d ?? body?.Data ?? body?.Result ?? body;
        return typeof replaced === 'string' ? replaced : jsonStr;
    } catch (err) {
        console.warn('replaceJsonStr error', err?.message || err);
        return jsonStr;
    }
}

export const sendWhatsAppTemplate = async (payload) => {
    const isInternalTemplatePayload = payload && typeof payload === 'object' && !!payload.whatsapp;

    if (isInternalTemplatePayload) {
        try {
            const base = (process.env.REACT_APP_SERVICES_API_BASE_URL || 'http://localhost:62194/').replace(/\/+$/, '');
            const url = `${base}/IMS/Internal/Whatsapp/Template`;
            console.debug('sendWhatsAppTemplate: POST', url);
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const json = await response.json().catch(() => null);
            if (!response.ok) {
                const message = json?.meta?.developer_message || json?.message || `HTTP ${response.status}`;
                console.warn('sendWhatsAppTemplate internal returned non-OK', { url, status: response.status, message, body: json });
                // Try fallback via serviceInstance if configured
                try {
                    const resp2 = await serviceInstance.post('IMS/Internal/Whatsapp/Template', payload);
                    return resp2?.data ?? resp2;
                } catch (err2) {
                    console.warn('sendWhatsAppTemplate fallback via serviceInstance failed', err2?.message || err2);
                }
                return { Status: 0, Message: `${message} (url: ${url})`, StatusCode: response.status };
            }
            return json || { Status: 1, Message: 'Success' };
        } catch (err) {
            console.warn('sendWhatsAppTemplate internal error', err?.message || err);
            return { Status: 0, Message: err?.message || 'Error' };
        }
    }

    const endpoints = [
        'UserCRM/SendWhatsAppTemplate',
        'UserCRM/SendWhatsappTemplate',
        'UserCRM/SendChannelTemplate'
    ];

    for (const endpoint of endpoints) {
        try {
            const resp = await serviceInstance.post(endpoint, payload);
            const body = resp?.data ?? resp;
            return body;
        } catch (err) {
            const status = err?.response?.status;
            if (status === 404) continue;
            console.warn('sendWhatsAppTemplate error', err?.message || err);
            return { Status: 0, Message: err?.message || 'Error' };
        }
    }

    return { Status: 0, Message: 'WhatsApp send endpoint not found.' };
}
export const getMailSmsDLTAccount = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetMailSmsDLTAccount', payload)
        // normalize response: serviceInstance.post returns { data: { Details: [...] } }
        const body = resp?.data ?? resp
        // main payload may place array under Details
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        // if list still has nested container, try common keys
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Accounts ?? list.Details ?? list
        }


        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getMailSmsDLTAccount error', err?.message || err)
        return []
    }
}

export const getSenderIdDLT = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetSenderIdDLT', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Accounts ?? list.Details ?? list
        }

        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getSenderIdDLT error', err?.message || err)
        return []
    }
}

export const sendSms = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SendSms', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendSms error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const sendMassSmsNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SendMassSMS_New', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassSmsNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const sendMassVoiceNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SendMassVoice_New', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassVoiceNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const sendMassInternationalSMSNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SendMassInternationalSMS_New', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassInternationalSMSNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const sendMassAddTagNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/AddMassTag_New', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassAddTagNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const sendMassAddCallListNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/LeadCallList_Click', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassAddCallListNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const sendMassRemoveTagNew = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/RemoveMassTag_New', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('sendMassRemoveTagNew error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const saveInternationalSms = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SaveInternationalSms', payload)
        const body = resp?.data ?? resp
        return body
    } catch (err) {
        console.warn('saveInternationalSms error', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const funcToGetEntityPlaceHolder = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/FuncToGetEntityPlaceHolder', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list
        }
        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('funcToGetEntityPlaceHolder error', err?.message || err)
        return []
    }
}

export const getDLTTemplates = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetDLTTemplates', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Templates ?? list
        }

        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getDLTTemplates error', err?.message || err)
        return []
    }
}

export const getDLTTemplateDetails = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetDLTTemplateDetails', payload)
        const body = resp?.data ?? resp
        let list = body?.Details ?? body?.data ?? body?.d ?? body
        if (typeof list === 'string') {
            try { list = JSON.parse(list) } catch (e) { /* ignore parse */ }
        }
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Templates ?? list
        }

        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getDLTTemplateDetails error', err?.message || err)
        return []
    }
}

export const getCustomUserTaskListByUserId = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetCustomUserTaskListByUserId', payload);
        const body = resp?.data ?? resp;
        // normalize into array
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getCustomUserTaskListByUserId error', err?.message || err);
        return [];
    }
}

export const insertNewTaskOrAppointmentLatest = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/InsertNewTaskOrAppointment_latest', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('insertNewTaskOrAppointmentLatest error', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const massInsertNewTaskOrAppointment = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/MassInsertNewTaskOrAppointment', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('massInsertNewTaskOrAppointment error', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const getFollowUpStatus = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetFollowUpStatus_new', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        // handle JSON.NET $values wrapper
        if (list && list.$values) list = list.$values;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.$values ?? list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        if (!Array.isArray(list)) return [];

        return list
            .map((item) => {
                const rawId = item?.Id ?? item?.id ?? item?.ID ?? item?.FollowupStatusId ?? item?.StatusId;
                const parsedId = Number.parseInt(String(rawId ?? ''), 10);
                const normalizedId = Number.isFinite(parsedId) ? parsedId : null;
                const rawCode = String(item?.Code ?? item?.code ?? item?.Value ?? item?.value ?? '').trim();
                const codeParts = rawCode.split(',').map((part) => String(part || '').trim()).filter(Boolean);
                const flagSource = codeParts.length ? codeParts : [];
                const canSetNextStatus = Number.parseInt(flagSource[1] ?? '', 10);
                const isConverted = Number.parseInt(flagSource[2] ?? '', 10);
                const fallbackCode = rawCode;

                return {
                    Id: normalizedId,
                    Code: String(normalizedId ?? fallbackCode ?? ''),
                    RawCode: rawCode,
                    CanSetNextStatus: Number.isFinite(canSetNextStatus) ? canSetNextStatus : null,
                    IsConverted: Number.isFinite(isConverted) ? isConverted : null,
                    Text: item?.Text ?? item?.text ?? item?.FollowupStatus ?? item?.Name ?? '',
                };
            })
            .filter((item) => item.Id !== null || item.Code || item.Text);
    } catch (err) {
        console.warn('getFollowUpStatus error', err?.message || err);
        return [];
    }
}

export const getProductsByName = async (payload) => {
    try {
        const resp = await serviceInstance.post(`UserCRM/GetProductsByName?t=${Date.now()}`, payload, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        });
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getProductsByName error', err?.message || err);
        return [];
    }
}

export const addLeadFollowupDLT = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/AddLeadFollowup_DLT', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('addLeadFollowupDLT error', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const addLeadFollowupDLTMassOperation = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/AddMassFollowup_New', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('addLeadFollowupDLTMassOperation error', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const assignLeadFollowupNewMassOperation = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/AssignLeadFollowup_New', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('assignLeadFollowupNewMassOperation error', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const getPipelines = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/FuncToGet_pipelines', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getPipelines error:', err?.message || err);
        return [];
    }
}

export const getDealPipeline = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetDealPipeline', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.$values) list = list.$values;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.$values ?? list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getDealPipeline error:', err?.message || err);
        return [];
    }
}

// Returns PipelineStage[] { Id, Name, Probability, IsDefault, Sequence }
export const getDealPipelineStage = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetDealPipelineStage', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.$values) list = list.$values;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.$values ?? list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getDealPipelineStage error:', err?.message || err);
        return [];
    }
}

export const getPipelineStages = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/FuncToGet_pipelineStages', payload);

        const body = resp?.data;

        // ✅ Directly take Details (your API returns here)
        const list = body?.Details;

        return Array.isArray(list) ? list : [];

    } catch (err) {
        console.warn('getPipelineStages error:', err?.message || err);
        return [];
    }
};

export const saveDealData = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SaveDealData', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('saveDealData error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const getUserWebformListByUserId = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetUserWebformListByUserId', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }
        // API returns CommonEntity objects with Code (FormId) and Text (FormName)
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getUserWebformListByUserId error:', err?.message || err);
        return [];
    }
}

export const getCollaboratorTypes = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/funcToGetCollTypeList', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.$values) list = list.$values;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.$values ?? list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getCollaboratorTypes error:', err?.message || err);
        return [];
    }
}

export const getTeamsByTypeId = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/funcToGetCollTeamList', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.$values) list = list.$values;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.$values ?? list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getTeamsByTypeId error:', err?.message || err);
        return [];
    }
}

export const getUserListByUserId = async (payload) => {
    try {
        const resp = await serviceInstance.post('Common/GetUserListByUserId', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Users ?? list.UserList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getUserListByUserId error:', err?.message || err);
        return [];
    }
}

export const getUserFromHashedListByUserId = async (payload) => {
    try {
        const resp = await serviceInstance.post('Common/GetUserFromHashedList', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Users ?? list.UserList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getUserFromHashedListByUserId error:', err?.message || err);
        return [];
    }
}

export const getChannelTemplateList = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetChannelTemplateList', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getChannelTemplateList error:', err?.message || err);
        return [];
    }
}
export const getChannelTemplateListByUserId = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GetChannelTemplateListByUserId_ByParam', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('GetChannelTemplateListByUserId error:', err?.message || err);
        return [];
    }
}

export const getIsLeadRegisterForWhatsapp = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/IsLeadRegisterForWhatsapp', payload)
        const body = resp?.data ?? resp
        // API returns ResponseStatusEntity or direct object in Details
        // prefer Details when present
        const details = body?.Details ?? body
        return details
    } catch (err) {
        console.warn('getIsLeadRegisterForWhatsapp error', err?.message || err)
        return null
    }
}

// export const getActiveApiKey = async (payload) => {
//     try {
//         const resp = await serviceInstance.post('IMSMOB/GetActiveApiKey', payload);
//         const body = resp?.data ?? resp;
//         const details = body?.Details ?? body;
//         return details;
//     } catch (err) {
//         console.warn('getActiveApiKey error', err?.message || err);
//         return null;
//     }
// }

export const generateWebFormUrl = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/GenerateWebformUrlWeb', payload);
        const body = resp?.data ?? resp;
        // The API returns ResponseStatusEntity with Details containing the URL string
        // Normalize to return the Details or the body itself
        return body;
    } catch (err) {
        console.warn('generateWebFormUrl error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const getCountryList = async (payload) => {
    try {
        const resp = await serviceInstance.post('Common/GetCountryList', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getCountryList error:', err?.message || err);
        return [];
    }
}

export const getStateListByCountryId = async (payload) => {
    try {
        const resp = await serviceInstance.post('Common/GetStateListByCountryId', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getStateListByCountryId error:', err?.message || err);
        return [];
    }
}

export const getCityListByStateId = async (payload) => {
    try {
        const resp = await serviceInstance.post('Common/GetCityListByStateId', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getCityListByStateId error:', err?.message || err);
        return [];
    }
}

export const bindSourceMediumCampaign = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/BindSourceMediumCampaign', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        // handle JSON.NET $values wrapper
        if (list && list.$values) list = list.$values;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.$values ?? list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('bindSourceMediumCampaign error:', err?.message || err);
        return [];
    }
}

export const getCustomFieldByParentId = async (payload) => {
    try {
        const resp = await serviceInstance.post('Common/GetCustomFieldByParentId', payload);
        const body = resp?.data ?? resp;
        let list = body?.Details ?? body?.data ?? body?.d ?? body;
        if (list && list.$values) list = list.$values;
        if (list && list.data) list = list.data;
        if (list && !Array.isArray(list)) {
            list = list.$values ?? list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list;
        }

        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getCustomFieldByParentId error:', err?.message || err);
        return [];
    }
}

export const updateField = async (payload) => {
    try {
        const resp = await serviceInstance.post('Common/UpdateField', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('updateField error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const saveNewLead = async (payload) => {
    try {
        // The server exposes this route as UserCRM/SaveNewLead (and also UserCRM/AddNewLead)
        const resp = await serviceInstance.post('UserCRM/SaveNewLead', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('saveNewLead error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const addLeadWithDependencies = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/AddLeadWithDependencies', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('addLeadWithDependencies error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const uploadLeadProfilePhoto = async (file, fileName) => {
    try {
        const base = (process.env.REACT_APP_KIT19_DOCS_PATH || 'https://docs.kit19.com').replace(/\/+$/, '');
        const cleanFileName = String(fileName || '').replace(/\s+/g, '');
        const safeName = encodeURIComponent(cleanFileName);
        // Always target the configured docs host and create the folder first
        const folderUrl = `${base}/profile_photo_lead/`;
        const fileUrl = `${folderUrl}${safeName}`;

        console.debug('uploadLeadProfilePhoto -> target folder', folderUrl);

        // Try to create folder (MKCOL). Many WebDAV hosts support this; server must allow MKCOL
        // in CORS Access-Control-Allow-Methods for browser requests to succeed.
        let corsBlocked = false;
        try {
            const mkcolResp = await fetch(folderUrl, { method: 'MKCOL', mode: 'cors', credentials: 'include' });
            console.debug('uploadLeadProfilePhoto -> MKCOL status', mkcolResp?.status, mkcolResp?.statusText);
        } catch (mkdirErr) {
            // Fetch throws a TypeError when CORS/preflight blocks the request (or network failures)
            console.warn('uploadLeadProfilePhoto create directory failed (MKCOL):', mkdirErr?.message || mkdirErr);
            if (mkdirErr && (mkdirErr instanceof TypeError || /Failed to fetch|NetworkError/i.test(String(mkdirErr)))) corsBlocked = true;
        }

        // Attempt direct PUT upload first (may be blocked by CORS). If blocked, fall back to proxy.
        const tryDirectPut = async () => {
            try {
                const resp = await fetch(fileUrl, {
                    method: 'PUT',
                    body: file,
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'Content-Type': file?.type || 'application/octet-stream',
                    },
                });

                if (!resp.ok) {
                    const status = resp.status;
                    let bodyText = null;
                    try { bodyText = await resp.text(); } catch (e) { }
                    console.warn('uploadLeadProfilePhoto PUT failed', status, bodyText ? bodyText.slice(0, 200) : '');
                    return { ok: false, status };
                }

                return { ok: true };
            } catch (putErr) {
                console.warn('uploadLeadProfilePhoto PUT error:', putErr?.message || putErr);
                if (putErr && (putErr instanceof TypeError || /Failed to fetch|NetworkError/i.test(String(putErr)))) corsBlocked = true;
                return { ok: false };
            }
        };

        // If we already detected CORS blocked on MKCOL, skip direct PUT and go to proxy fallback
        if (!corsBlocked) {
            const putResult = await tryDirectPut();
            if (putResult.ok) return { Status: 1, Message: 'Uploaded', FileName: cleanFileName };
        }

        // Fallback: use upload proxy (same-origin or configured) to avoid browser CORS restrictions
        const proxyUrl = (process.env.REACT_APP_UPLOAD_PROXY_URL || '/api/uploadProfilePhoto').replace(/\/?$/, '');
        try {
            const form = new FormData();
            // 'file' key expected by server/uploadProxy.js
            form.append('file', file, cleanFileName);
            form.append('fileName', cleanFileName);

            const proxyResp = await fetch(proxyUrl, { method: 'POST', body: form, credentials: 'same-origin' });
            let json = null;
            try { json = await proxyResp.json(); } catch (e) { json = null; }

            if (proxyResp.ok) {
                // server proxy returns JSON with Status
                if (json && (json.Status === 1 || json.status === 'ok' || json.success)) {
                    return { Status: 1, Message: 'Uploaded via proxy', FileName: cleanFileName };
                }
                // if proxy succeeded at HTTP level but didn't return expected body, still consider success
                return { Status: 1, Message: 'Uploaded via proxy', FileName: cleanFileName };
            }

            console.warn('uploadLeadProfilePhoto proxy upload failed', proxyResp.status, json);
            return { Status: 0, Message: json?.Message || `Proxy upload failed with status ${proxyResp.status}` };
        } catch (proxyErr) {
            console.warn('uploadLeadProfilePhoto proxy error:', proxyErr?.message || proxyErr);
            const hint = corsBlocked ? 'CORS blocked direct browser upload. Either enable MKCOL/PUT in docs server CORS or run the upload proxy.' : 'Upload failed';
            return { Status: 0, Message: proxyErr?.message ? `${proxyErr.message} — ${hint}` : hint };
        }
    } catch (err) {
        console.warn('uploadLeadProfilePhoto error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Upload failed' };
    }
}

export const editLead = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/EditLead', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('editLead error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}
export const uploadLeadDocument = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/UploadLeadDocuments', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('uploadLeadDocument error', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
};

export const checkPermissionGetDnid = async (payload) => {
    try {
        const response = await serviceInstance.post('ClicktoCall/CheckPermissionGetDnid', payload);
        return response.data;
    } catch (error) {
        console.error('checkPermissionGetDnid error:', error);
        throw error;
    }
};

export const mergeLeadToLeadNew = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/MergeLeadToLead', payload);
        return response.data;
    } catch (error) {
        console.error('mergeLeadToLeadNew error:', error);
        throw error;
    }
};

export const searchLeadByLeadNo = async (payload) => {
    try {
        const response = await serviceInstance.post('UserCRM/SearchLeadByLeadNo', payload);
        return response.data;
    } catch (error) {
        console.error('searchLeadByLeadNo error:', error);
        throw error;
    }
};

export const saveInvoice = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SaveInvoice', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('saveInvoice error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const saveQuotation = async (payload) => {
    try {
        const resp = await serviceInstance.post('UserCRM/SaveQuotation', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('saveQuotation error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}
export const saveTaxSetting = async (payload) => {
    try {
        const details = payload?.Details || {}
        const params = {
            Id: details.Id || 0,
            HasTaxNumber: !!details.hasTaxNumber,
            TaxNumber: details.taxNumber || '',
            Address: details.address || '',
            CountryId: parseInt(details.countryId) || 0,
            StateId: parseInt(details.stateId) || 0,
            CityId: parseInt(details.cityId) || 0,
            PinCode: details.pincode || '',
            IsDefault: !!details.isDefault,
            LeadId: parseInt(details.LeadId) || 0,
            UserId: parseInt(details.UserId) || 0,
            PersonName: details.personName || '',
            CompanyName: details.companyName || '',
            PanNumber: details.panNumber || ''
        }
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/InsertUpdateLeadTax', params)
        const body = resp?.data?.d ?? resp?.data ?? resp
        if (typeof body === 'string') {
            try {
                return JSON.parse(body)
            } catch (e) {
                return body
            }
        }
        return body
    } catch (err) {
        console.warn('saveTaxSetting error:', err?.message || err)
        return { Status: 0, Message: err?.message || 'Error' }
    }
}

export const getLeadCustomerSuggection = async (payload) => {
    try {
        const details = payload?.Details || {}
        const params = {
            UserId: parseInt(details.UserId) || 0,
            FilterText: details.FilterText || ''
        }
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/GetLeadCustomerSuggection', params)
        const body = resp?.data?.d ?? resp?.data ?? resp
        let list = []
        if (typeof body === 'string') {
            try {
                const parsed = JSON.parse(body);
                list = parsed?.d ?? parsed;
            } catch (e) {
                list = [];
            }
        } else {
            list = body
        }
        if (list && list.d) list = list.d;
        if (list && list.$values) list = list.$values
        return Array.isArray(list) ? list : []
    } catch (err) {
        console.warn('getLeadCustomerSuggection error:', err?.message || err)
        return []
    }
}

export const getSettingBySection = async (params) => {
    try {
        const { token, TokenId } = getSession();
        const activeToken = token || TokenId || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token');
        
        const payload = {
            Token: activeToken,
            ...params
        };

        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/GetSettingBySection', payload);
        const body = resp?.data?.d ?? resp?.data ?? resp;
        let list = [];
        if (typeof body === 'string') {
            try {
                const parsed = JSON.parse(body);
                list = parsed?.d ?? parsed;
            } catch (e) {
                list = [];
            }
        } else {
            list = body;
        }
        if (list && list.d) list = list.d;
        if (list && list.$values) list = list.$values;
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getSettingBySection error:', err?.message || err);
        return [];
    }
};

export const insertUpdateSettings = async (params) => {
    try {
        const { TokenId } = getSession();
        // Enforce the universal token as requested
        const activeToken = "-2295521862261168";
        
        const details = { ...params };
        if (details.list) {
            details.InvoiceSettings = details.list;
            delete details.list;
        }

        const payload = {
            Token: activeToken,
            Details: details
        };

        const resp = await serviceInstance.post('Invoice/InsertUpdateSettings', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('insertUpdateSettings error:', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
};

export const getLeadSuggectionById = async (params) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/LeadSuggectionById', params);
        const body = resp?.data?.d ?? resp?.data ?? resp;
        if (typeof body === 'string') {
            try { return JSON.parse(body); } catch (e) { return null; }
        }
        return body;
    } catch (err) {
        console.warn('getLeadSuggectionById error:', err?.message || err);
        return null;
    }
};

export const getInvoiceCurrencyList = async () => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/GetInvoiceCurrencyList', {});
        const body = resp?.data?.d ?? resp?.data ?? resp;
        let list = [];
        if (typeof body === 'string') {
            try { list = JSON.parse(body); } catch (e) { list = []; }
        } else {
            list = body;
        }
        if (list && list.$values) list = list.$values;
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getInvoiceCurrencyList error:', err?.message || err);
        return [];
    }
};

export const getProductForSuggetion = async (params) => {
    try {
        const resp = await wcfInstance.post(`/UserCRMCampaign/Service/InvoiceService.asmx/GetProductForSuggetion?t=${Date.now()}`, params, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        });
        const body = resp?.data?.d ?? resp?.data ?? resp;
        let list = [];
        if (typeof body === 'string') {
            try {
                const parsed = JSON.parse(body);
                list = parsed?.d ?? parsed;
            } catch (e) {
                list = [];
            }
        } else {
            list = body;
        }
        if (list && list.d) list = list.d;
        if (list && list.$values) list = list.$values;
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getProductForSuggetion error:', err?.message || err);
        return [];
    }
};

export const insertNewInvoice = async (params) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/InsertNewInvoice', params);
        return resp?.data?.d ?? resp?.data ?? resp;
    } catch (err) {
        console.error('insertNewInvoice error:', err?.message || err);
        throw err;
    }
};

export const insertNewQuote = async (params) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/InsertNewQuote', params);
        return resp?.data?.d ?? resp?.data ?? resp;
    } catch (err) {
        console.error('insertNewQuote error:', err?.message || err);
        throw err;
    }
};

export const isQuotationNumberAlreadyExists = async (params) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/IsQuotationNumberAlreadyExists', params);
        return resp?.data?.d ?? resp?.data ?? resp;
    } catch (err) {
        console.error('isQuotationNumberAlreadyExists error:', err?.message || err);
        throw err;
    }
};

export const getInvoiceSuggestionsCreditNote = async (params) => {
    try {
        const payload = {
            LeadId: parseInt(params?.LeadId) || 0,
            FilterText: params?.FilterText || ''
        };
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/GetInvoiceSuggestionsCreditNote', payload);
        const body = resp?.data?.d ?? resp?.data;
        if (!body) return [];

        let list = [];
        if (typeof body === 'string') {
            try { list = JSON.parse(body); } catch (e) { list = []; }
        } else {
            list = body;
        }

        if (list && list.$values) list = list.$values;
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getInvoiceSuggestionsCreditNote error:', err?.message || err);
        return [];
    }
};

export const getTaxesForSuggetion = async (params) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/GetTaxesForSuggetion', params);
        const body = resp?.data?.d ?? resp?.data ?? resp;
        let list = [];
        if (typeof body === 'string') {
            try { list = JSON.parse(body); } catch (e) { list = []; }
        } else {
            list = body;
        }
        if (list && list.$values) list = list.$values;
        return Array.isArray(list) ? list : [];
    } catch (err) {
        console.warn('getTaxesForSuggetion error:', err?.message || err);
        return [];
    }
};

export const insertNewCreditNote = async (params) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/InsertNewCreditNote', params);
        return resp?.data?.d ?? resp?.data ?? resp;
    } catch (err) {
        console.error('insertNewCreditNote error:', err?.message || err);
        throw err;
    }
};

export const isCreditNoteNumberAlreadyExists = async (params) => {
    try {
        const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/IsCreditNoteNumberAlreadyExists', params);
        return resp?.data?.d ?? resp?.data ?? resp;
    } catch (err) {
        console.error('isCreditNoteNumberAlreadyExists error:', err?.message || err);
        throw err;
    }
};

export const getCreditNoteList = async (params) => {
    try {
        const response = await serviceInstance.post('Invoice/GetCreditNoteListById', params);
        return response.data;
    } catch (err) {
        console.error('getCreditNoteList error:', err?.message || err);
        throw err;
    }
};

export const getActiveApiKey = async (payload) => {
    try {
        const resp = await serviceInstance.post('IMSMOB/GetActiveApiKey', payload);
        const body = resp?.data ?? resp;
        const details = body?.Details ?? body;
        return details;
    } catch (err) {
        console.warn('getActiveApiKey error', err?.message || err);
        return null;
    }
}

// export const getCreditNoteDetailById = async (params) => {
//     try {
//         const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/GetCreditNoteDetailById', params);
//         return resp?.data?.d ?? resp?.data ?? resp;
//     } catch (err) {
//         console.error('getCreditNoteDetailById error:', err?.message || err);
//         throw err;
//     }
// };

// export const updateCreditNoteStatusById = async (params) => {
//     try {
//         const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/UpdateCreditNoteStatusByIds', params);
//         return resp?.data?.d ?? resp?.data ?? resp;
//     } catch (err) {
//         console.error('updateCreditNoteStatusById error:', err?.message || err);
//         throw err;
//     }
// };

// export const saveApprovalSetting = async (params) => {
//     try {
//         const resp = await wcfInstance.post('/UserCRMCampaign/Service/InvoiceService.asmx/SaveApprovalSetting', params);
//         return resp?.data?.d ?? resp?.data ?? resp;
//     } catch (err) {
//         console.error('saveApprovalSetting error:', err?.message || err);
//         throw err;
//     }
// };

export const associateDeissociateWrapper = async (payload) => {
    try {
        const resp = await serviceInstance.post('IMSMOB/AssociateDeissociateWrapper', payload);
        const body = resp?.data ?? resp;
        return body;
    } catch (err) {
        console.warn('associateDeissociateWrapper error', err?.message || err);
        return { Status: 0, Message: err?.message || 'Error' };
    }
}

export const getCustomerLedgerSummaryList = async (payload) => {
    try {
        const response = await serviceInstance.post('Invoice/GetCustomeredgerSummaryList', payload);
        return response.data;
    } catch (error) {
        console.error('getCustomerLedgerSummaryList error:', error);
        throw error;
    }
}

export const getCurrencyListByUserID = async (userid) => {
    try {
        const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
        const payload = {
            Token: "-2295521862261168",
            Details: {
                UserId: parseInt(userid, 10)
            }
        };
        const endpoint = API_ENDPOINTS.INVOICE.GET_CURRENCY_LIST_BY_USER_ID;
        const url = `${NEWV3_BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`;
        
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('getCurrencyListByUserID error:', error);
        throw error;
    }
}


export const getProductUnitList = async (params) => {
    try {
        const session = getSession();
        const activeToken = session?.TokenId || session?.token || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token') || '-2295521862261168';
        const cleanParams = { ...params };
        if (cleanParams.strUserID) { cleanParams.UserId = cleanParams.strUserID; delete cleanParams.strUserID; }
        const payload = { Token: activeToken, Details: JSON.stringify(cleanParams) };
        const resp = await serviceInstance.post(API_ENDPOINTS.PRODUCT.GET_UNIT_LIST, payload);
        return resp?.data?.Details ?? resp?.data ?? [];
    } catch (err) {
        console.warn('getProductUnitList error', err);
        return [];
    }
};

export const getProductCategoryList = async (params) => {
    try {
        const session = getSession();
        const activeToken = session?.TokenId || session?.token || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token') || '-2295521862261168';
        const cleanParams = { ...params };
        if (cleanParams.strUserID) { cleanParams.UserId = cleanParams.strUserID; delete cleanParams.strUserID; }
        const payload = { Token: activeToken, Details: JSON.stringify(cleanParams) };
        const resp = await serviceInstance.post(API_ENDPOINTS.PRODUCT.GET_CATEGORY_LIST, payload);
        return resp?.data?.Details ?? resp?.data ?? [];
    } catch (err) {
        console.warn('getProductCategoryList error', err);
        return [];
    }
};

export const getProductTaxList = async (params) => {
    try {
        const session = getSession();
        const activeToken = session?.TokenId || session?.token || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token') || '-2295521862261168';
        const cleanParams = { ...params };
        if (cleanParams.strUserID) { cleanParams.UserId = cleanParams.strUserID; delete cleanParams.strUserID; }
        const payload = { Token: activeToken, Details: JSON.stringify(cleanParams) };
        const resp = await serviceInstance.post(API_ENDPOINTS.PRODUCT.GET_TAX_LIST, payload);
        return resp?.data?.Details ?? resp?.data ?? [];
    } catch (err) {
        console.warn('getProductTaxList error', err);
        return [];
    }
};

export const getProductAccountList = async (params) => {
    try {
        const session = getSession();
        const activeToken = session?.TokenId || session?.token || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token') || '-2295521862261168';
        const cleanParams = { ...params };
        if (cleanParams.strUserID) { cleanParams.UserId = cleanParams.strUserID; delete cleanParams.strUserID; }
        const payload = { Token: activeToken, Details: JSON.stringify(cleanParams) };
        const resp = await serviceInstance.post(API_ENDPOINTS.PRODUCT.GET_ACCOUNT_LIST, payload);
        return resp?.data?.Details ?? resp?.data ?? [];
    } catch (err) {
        console.warn('getProductAccountList error', err);
        return [];
    }
};

export const getProductCustomFields = async (params) => {
    try {
        const session = getSession();
        const activeToken = session?.TokenId || session?.token || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token') || '-2295521862261168';
        const cleanParams = { ...params };
        if (cleanParams.strUserID) { cleanParams.UserId = cleanParams.strUserID; delete cleanParams.strUserID; }
        const payload = { Token: activeToken, Details: JSON.stringify(cleanParams) };
        const resp = await serviceInstance.post(API_ENDPOINTS.PRODUCT.GET_CUSTOM_FIELDS, payload);
        return resp?.data?.Details ?? resp?.data ?? [];
    } catch (err) {
        console.warn('getProductCustomFields error', err);
        return [];
    }
};

export const saveProduct = async (params) => {
    try {
        const session = getSession();
        const activeToken = session?.TokenId || session?.token || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token') || '-2295521862261168';
        const cleanParams = params?.productDetailsToSave_Obj || params;
        if (params?.strUserID && !cleanParams.UserId) { cleanParams.UserId = params.strUserID; }
        const payload = { Token: activeToken, Details: JSON.stringify(cleanParams) };
        const resp = await serviceInstance.post(API_ENDPOINTS.PRODUCT.SAVE_PRODUCT, payload);
        return resp?.data?.Details ?? resp?.data;
    } catch (err) {
        console.error('saveProduct error', err);
        throw err;
    }
};

export const getTagListWithFilter = async (params) => {
    try {
        const session = getSession();
        const activeToken = session?.TokenId || session?.token || sessionStorage.getItem('deviceToken') || sessionStorage.getItem('Token') || '-2295521862261168';
        const cleanParams = { ...params };
        if (cleanParams.strUserID) { cleanParams.UserId = cleanParams.strUserID; delete cleanParams.strUserID; }
        if (cleanParams.strFilter !== undefined) { cleanParams.Filter = cleanParams.strFilter; delete cleanParams.strFilter; }
        const payload = { Token: activeToken, Details: JSON.stringify(cleanParams) };
        const resp = await serviceInstance.post(API_ENDPOINTS.PRODUCT.GET_TAG_LIST, payload);
        return resp?.data?.Details ?? resp?.data ?? [];
    } catch (err) {
        console.warn('getTagListWithFilter error', err);
        return [];
    }
};


// ── Credit Note WCF API functions ──────────────────────────────────────────────

export const getCreditNoteDetailById = async (payload) => {
    try {
        const response = await wcfInstance.post('UserCRMCampaign/Service/InvoiceService.asmx/GetCreditNoteDetailById', payload);
        return response.data?.d ?? response.data;
    } catch (error) {
        console.error('getCreditNoteDetailById error:', error);
        throw error;
    }
};

export const updateCreditNoteStatusById = async (payload) => {
    try {
        const response = await wcfInstance.post('UserCRMCampaign/Service/InvoiceService.asmx/UpdateCreditNoteStatusByIds', payload);
        return response.data?.d ?? response.data;
    } catch (error) {
        console.error('updateCreditNoteStatusById error:', error);
        throw error;
    }
};

export const saveApprovalSetting = async (payload) => {
    try {
        const response = await wcfInstance.post('UserCRMCampaign/Service/InvoiceService.asmx/SaveApprovalSetting', payload);
        return response.data?.d ?? response.data;
    } catch (error) {
        console.error('saveApprovalSetting error:', error);
        throw error;
    }
};

export const getApprovalEntitySetting = async (payload) => {
    try {
        const response = await wcfInstance.post('UserCRMCampaign/Service/InvoiceService.asmx/GetApprovalEntitySettingByEntity', payload);
        return response.data?.d ?? response.data;
    } catch (error) {
        console.error('getApprovalEntitySetting error:', error);
        throw error;
    }
};

export const getApprovalHistory = async (payload) => {
    try {
        const response = await wcfInstance.post('UserCRMCampaign/Service/InvoiceService.asmx/GetInvoiceApprovedData', payload);
        return response.data?.d ?? response.data;
    } catch (error) {
        console.error('getApprovalHistory error:', error);
        throw error;
    }
};

export const saveApprovedData = async (payload) => {
    try {
        const response = await wcfInstance.post('UserCRMCampaign/Service/InvoiceService.asmx/SaveAprrovedData', payload);
        return response.data?.d ?? response.data;
    } catch (error) {
        console.error('saveApprovedData error:', error);
        throw error;
    }
};

// ── Lead Custom Search (getLeadCustomSearch WCF WebMethod) ─────────────────────
export const getLeadCustomSearch = async ({ UserId }) => {
    try {
        const response = await wcfInstance.post(
            'UserCRMCampaign/Service/LeadAssignmentService.asmx/getLeadCustomSearch',
            { strUserID: String(UserId) }
        );
        // Response is { d: "[JSON string]" } — double encoded
        const raw = response?.data?.d;
        if (!raw) return [];
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!Array.isArray(parsed)) return [];
        // Filter to only Lead type (SP already filters, but guard anyway)
        return parsed.filter(item =>
            (item.CriteriaType || '').toLowerCase() === 'lead'
        );
    } catch (err) {
        console.error('getLeadCustomSearch error:', err);
        return [];
    }
};

// ── Module Permission by ModuleCode & UserId ───────────────────────────────────
export const getAllPermissionByModuleCodeUserId = async ({ Mode = 'S', ModuleCode, UserId, Token }) => {
    try {
        const { getSession } = await import('../getSession');
        const session = getSession();
        const payload = {
            Token: Token || session.TokenId,
            Details: JSON.stringify({ Mode, ModuleCode, UserId: Number(UserId) })
        };
        const response = await serviceInstance.post('UserAuth/GetAllPermissionByModuleCodeUserId', payload);
        const body = response?.data ?? response;
        if (body?.Status === 1) {
            return body.Details ?? null;
        }
        return null;
    } catch (err) {
        console.error('getAllPermissionByModuleCodeUserId error:', err);
        return null;
    }
};

// ── Call Log (WCF CRMService.asmx/getCallLog) ──────────────────────────────────
export const getCallLog = async ({ EntityName = 'Lead', EntityID, Start = 0, Limit = 10 }) => {
    try {
        const response = await wcfInstance.post(
            'UserCRMCampaign/Service/CRMService.asmx/getCallLog',
            { EntityName, EntityID, Start, Limit }
        );
        // Response: { d: "[JSON string]" }
        const raw = response?.data?.d;
        if (!raw) return [];
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
        console.error('getCallLog error:', err);
        return [];
    }
};

// ── Check Lead Permission (Lead-Specific Permission check) ─────────────────────
export const checkLeadPermission = async ({ leadId, logUserId, Token }) => {
    try {
        const { getSession } = await import('../getSession');
        const session = getSession();
        const payload = {
            Token: Token || session.TokenId,
            Details: JSON.stringify({ leadId: Number(leadId), logUserId: Number(logUserId) })
        };
        const response = await serviceInstance.post('UserCRM/CheckLeadPermission', payload);
        const body = response?.data ?? response;
        if (body?.Status === 1) {
            return body.Details ?? null;
        }
        return null;
    } catch (err) {
        console.error('checkLeadPermission error:', err);
        return null;
    }
};

// ── Get Field Masked List (WCF FieldMasked.asmx/getfieldmasked) ─────────────────
export const getFieldMasked = async ({ ParentId, UserId, PageCode }) => {
    try {
        const response = await wcfInstance.post(
            'UserCRMCampaign/Service/FieldMasked.asmx/getfieldmasked',
            { ParentId: Number(ParentId), UserId: Number(UserId), PageCode: String(PageCode) }
        );
        const data = response?.data;
        if (data && data.d) {
            if (typeof data.d === 'string') {
                try {
                    return { d: JSON.parse(data.d) };
                } catch (e) {
                    return data;
                }
            }
            return data;
        }
        return data ?? { d: [] };
    } catch (err) {
        console.error('getFieldMasked error:', err);
        return { d: [] };
    }
};

// ── Get Country Flags and Codes (restcountries.com) ────────────────────────
export const fetchCountryFlagsAndCodes = async () => {
    try {
        const response = await fetch('https://raw.githubusercontent.com/mledoze/countries/master/countries.json');
        const data = await response.json();
        const mapped = data.map(c => {
            const root = c.idd?.root || '';
            const suffix = c.idd?.suffixes?.[0] || '';
            return {
                name: c.name.common,
                flag: c.flags?.png || `https://flagcdn.com/w320/${(c.cca2 || '').toLowerCase()}.png`,
                dialCode: root + suffix,
                code: c.cca2
            };
        }).filter(c => c.dialCode)
          .sort((a, b) => a.name.localeCompare(b.name));

        return mapped;
    } catch (error) {
        // Silently catch CORS block to avoid console errors
        return [];
    }
};
